app.Timeout = (
    function () {
        var timeout = {
            //Init is used to start the timer modal popup.
            Init: function () {
                $('#modalAutoLogout').each(function () {
                    var validationFrequency = $(this).data('timeout-frequency') * 1000;
                    var timeoutDurationDefault = ($(this).data('timeout-duration-default') * 60000) - validationFrequency;//subtract time to remove mistimed identity validation and convert to milliseconds
                    var timeoutDurationTrusted = ($(this).data('timeout-duration-trusted') * 60000) - validationFrequency;//subtract time to remove mistimed identity validation and convert to milliseconds
                    var trustedCookieName = $(this).data('timeout-trusted-cookie-name');
                    var timeoutDuration = !$.cookie(trustedCookieName) ? timeoutDurationDefault : timeoutDurationTrusted;
                    app.Page.timeoutWarningMinutes = $(this).data('timeout-warning');
                    var timeoutWarning = app.Page.timeoutWarningMinutes * 60000;//convert to milliseconds
                    var warningTimeout = timeoutWarning;
                    var timoutNow = timeoutDuration - warningTimeout;
                    var warningTimerID, timeoutTimerID;
                    app.Page.intervalTimerID = null;

                    function startTimer() {
                        // window.setTimeout returns an Id that can be used to start and stop a timer
                        warningTimerID = window.setTimeout(warningInactive, timoutNow);
                    }

                    function warningInactive() {
                        window.clearTimeout(warningTimerID);
                        timeoutTimerID = window.setTimeout(IdleTimeout, warningTimeout);
                        if (app.Page.intervalTimerID) {
                            clearTimeout(app.Page.intervalTimerID);
                        }
                        app.Page.intervalTimerID = app.Timeout.StartCountdown(app.Page.timeoutWarningMinutes);
                        $('#modalAutoLogout').modal('show');
                    }

                    function resetTimer() {
                        window.clearTimeout(timeoutTimerID);
                        window.clearTimeout(warningTimerID);
                        window.clearTimeout(app.Page.intervalTimerID);
                        app.Timeout.ClearCountdown();
                        startTimer();
                    }

                    // Logout the user.
                    function IdleTimeout() {
                        $('.modal-body', '#modalAutoLogout').html('<p class="danger">If this is your only tab you are working in, you have been automatically logged out and any unsaved data is lost.</p>');
                        $('#btnStayLoggedIn').text("Close");
                    }

                    function setupTimers() {
                        startTimer();
                    }

                    $(document).on('click', '#btnStayLoggedIn', function () {
                        $('#modalAutoLogout').modal('hide');
                        //send ajax post to stay logged in
                        $.post("/Account/StayLoggedIn")
                            .fail(function () {
                                window.location = "/?ReturnUrl=" + encodeURIComponent(window.location.pathname);
                            })
                            .done(function ()
                            {
                                if ($('#btnStayLoggedIn').text() === "Close")
                                {
                                    //Since the timing isn't 100% it is possible that "Close" button and the cookie werent in sync
                                    //and the cookie was still valid, resulting in a successful update of the cookie from the StayLoggedIn call. 
                                    //If this is the case we we want to make sure to change the language of the modal back to default. 
                                    $('.modal-body', '#modalAutoLogout').html("<p>If this is your only tab, you will be logged out automatically soon: <span id='divAutoLogoutCountdown'>" + app.Page.timeoutWarningMinutes + ":00</span>.</p>");
                                    $('#btnStayLoggedIn').text("Stay Logged In");
                                }
                                resetTimer();
                                toastr.success("Success: you are still logged in.");
                            });
                    });

                    setupTimers();
                });
            },
            StartCountdown: function (minutesIn) {
                var timer2 = minutesIn + ":00";
                var interval = setInterval(function () {
                    var timer = timer2.split(':');
                    //by parsing integer, I avoid all extra string processing
                    var minutes = parseInt(timer[0], 10);
                    var seconds = parseInt(timer[1], 10);
                    --seconds;
                    minutes = (seconds < 0) ? --minutes : minutes;
                    seconds = (seconds < 0) ? 59 : seconds;
                    seconds = (seconds < 10) ? '0' + seconds : seconds;
                    //minutes = (minutes < 10) ?  minutes : minutes;
                    $('#divAutoLogoutCountdown').html(minutes + ':' + seconds);
                    if (minutes < 0) clearInterval(interval);
                    //check if both minutes and seconds are 0
                    if ((seconds <= 0) && (minutes <= 0)) clearInterval(interval);
                    timer2 = minutes + ':' + seconds;
                }, 1000);
                return interval;
            },
            ClearCountdown: function () {
                $('#divAutoLogoutCountdown').html(app.Page.timeoutWarningMinutes + ":00");
            }
        }
        return timeout;
    }()
);